import React, { useCallback, useEffect, useState } from "react";
import CommonAdminTable from "../components/commonTable";
import { Input, Pagination, Tag, Typography } from "antd";
import Search from "antd/es/transfer/search";
import { useDispatch } from "react-redux";
import { AllProductsPricingListAPI } from "../../redux/actions/adminActions/listsAction";
import Alertify from "../../services/alertify";
import { useLocation } from "wouter";
import { getQueryParams } from "../../utilities/getQueryParams";
const { Title, Text } = Typography;

const ProductsPricingList = () => {
  const columns = [
    {
      title: "Index",
      dataIndex: "index",
      key: "index",
      fixed: "left",
      align: "center",
    },

    {
      title: "Title",
      dataIndex: "title",
      key: "title",
      render: (text) => <Text className="uppercase">{text}</Text>,
    },
    {
      title: "ERP Item Code",
      dataIndex: "erp_item_code",
      key: "erp_item_code",
      align: "center",
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type",
      fixed: "left",
      render: (text) => <Text className="capitalize">{text}</Text>,
    },
    {
      title: "Dealer Code",
      dataIndex: "dealer_code",
      key: "dealer_code",
      render: (text) => <Text className="uppercase">{text}</Text>,
    },
    {
      title: "Branch",
      dataIndex: "responsibility_center",
      key: "dealer_code",
      render: (text) => <Text className="uppercase">{text}</Text>,
    },
    {
      title: "MRP",
      dataIndex: "mrp",
      key: "mrp",
      align: "center",
    },
    {
      title: "Unit Price",
      dataIndex: "unit_price",
      key: "unit_price",
      align: "center",
    },
    {
      title: "Starting Date",
      dataIndex: "starting_date",
      key: "starting_date",
      align: "center",
    },
    {
      title: "Ending Date",
      dataIndex: "ending_date",
      key: "ending_date",
      align: "center",
    },
    {
      title: "Status",
      key: "status",
      dataIndex: "status",
      align: "center",
      render: (text) => {
        let color = text === "Active" ? "green" : "volcano";
        return (
          <Tag color={color} key={text}>
            {text.toUpperCase()}
          </Tag>
        );
      },
    },
  ];

  const [totalProducts, setTotalProducts] = useState(0);
  const [allProducts, setAllProducts] = useState([]);
  const [, navigate] = useLocation();
  const params = getQueryParams();
  const initialPage = params.page || 1;
  const [currentPage, setCurrentPage] = useState(initialPage);
  const [searchValue, setSearchValue] = useState("");

  const handlePageChange = (page) => {
    setCurrentPage(page);
    navigate(`/admin/products-pricing?page=${page}`);
  };
  useEffect(() => {
    document.title = "Products: ALP Shop";
  }, []);

  const dispatch = useDispatch();
  const fetchProductsPrice = useCallback(() => {
    const data = {
      currentPage: currentPage,
      perPage: 10,
      search: searchValue,
    };
    dispatch(AllProductsPricingListAPI(data))
      .then((response) => {
        if (
          response.payload &&
          response.payload.data &&
          response.payload.data.data
        ) {
          const productsWithIndex = response.payload.data.data.map(
            (product, index) => ({
              ...product,
              index: index + 1 + (currentPage - 1) * 10,
            }),
          );
          setAllProducts(productsWithIndex);
          const total = response.payload.data.pagination.total || 0;
          setTotalProducts(total);
          // console.log("All Products are:+++", productsWithIndex);
        } else {
          throw new Error("Unexpected API response structure");
        }
      })
      .catch((error) => {
        Alertify.error(
          "Failed to fetch the all products list: " + error.message,
        );
      });
  }, [currentPage, dispatch, searchValue]);
  useEffect(() => {
    const handler = setTimeout(() => {
      fetchProductsPrice();
    }, 300);
    return () => clearTimeout(handler);
  }, [fetchProductsPrice]);

  return (
    <>
      <Title level={2} className="text-left pb-4">
        Products
      </Title>
      <div className="mb-8 flex items-center justify-between max-sm:flex-col max-sm:gap-4">
        <div className="sm:w-1/3">
          <Input
            placeholder="Search"
            value={searchValue}
            onChange={(e) => {
              setSearchValue(e.target.value);
              setCurrentPage(1);
            }}
          />
        </div>
      </div>
      <CommonAdminTable columns={columns} data={allProducts} />
      <div className="flex justify-between items-center mt-4">
        <Pagination
          current={currentPage}
          total={totalProducts}
          pageSize={10}
          onChange={handlePageChange}
          showSizeChanger={false}
        />
      </div>
    </>
  );
};

export default ProductsPricingList;
